export default ({ app }, inject) => {
  // Inject $hello(msg) in Vue, context and store.
  inject(
    'isEmpty',
    (value) =>
      value === undefined ||
      value === null ||
      (typeof value === 'object' && Object.keys(value).length === 0) ||
      (typeof value === 'string' && value.trim().length === 0)
  )
}
